module.exports = __webpack_public_path__ + "img/delete_magento.97508ab2.svg";